module.exports = __webpack_public_path__ + "img/brandbg.0996653e.jpg";